import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=e5041756&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=ts"
export * from "./ItemCard.vue?vue&type=script&lang=ts"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=e5041756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5041756",
  null
  
)

export default component.exports